import { Component, Input, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ContractControlService, IGetContractById } from '../contract-control.service';
import { HttpErrorResponse } from '@angular/common/http';
import { GlobalService } from 'app/global/global.service';


@Component({
  selector: 'app-contract-control-indexdata-modal',
  templateUrl: './contract-control-indexdata-modal.component.html',
  styleUrls: ['./contract-control-indexdata-modal.component.scss']
})
export class ContractControlIndexdataModalComponent implements OnInit {
  @Input() contract_id: number;
  
  public indexData: IGetContractById;
  public contractLengths = {
    "0": "Continuous",
    "1": "1 Month",
    "2": "2 Months",
    "3": "3 Months",
    "6": "6 Months",
    "12": "12 Months",
    "18": "18 Months",
    "24": "24 Months",
    "36": "36 Months",
    "48": "48 Months",
    "60": "5 Years",
    "120": "10 Years",
    "-1": "Other",
    "7d": "1 Week",
    "14d": "2 Weeks",
    "21d": "3 Weeks"
  };
  public isDataloaded: boolean = false;

  /**
   * Constructor
   * @param modalService 
   * @param contractControlService 
   */
  constructor (
    public _modalService: NgbModal, 
    private _contractControlService: ContractControlService,
    private _globalService: GlobalService,
  ) {}



  ngOnInit(): void {
    this.getIndexData();
  }


    /**
   * Returns contract_control_name property value from the given Object. It returns empty string for null/undefined Object or that which does not contain name property
   * @param item
   */
    getContractNameColumnFromObject(item:{contract_control_name:string}): string{
      return item?.contract_control_name || '';
    }

  

  /**
   * Fetches the index data for the current contract by calling the contract control service.
   * 
   * On successful response, assigns the received data to `indexData` and sets `isDataloaded` to `true`.
   * If an error occurs, displays an error message using the global service's toastr.
   *
   * @remarks
   * This method relies on the contract ID (`contract_id`) being set prior to invocation.
   * It handles both success and error scenarios for the HTTP request.
   */
  getIndexData(): void {
    this._contractControlService.contactControlIndexData(this.contract_id).subscribe({
      next: (response) => {
        this.indexData = response.data;
        this.isDataloaded = true;
      }, 
      error: (error: HttpErrorResponse) => {
        this._globalService.toastrError(error.error.message || error.message);
      },
    })
  }




  closeModal(){
    this._modalService.dismissAll();
  }
}
